<template>
  <div>
    <div v-if="!onDocumentClick">
      <div class="">
        <p class="global-activity-title border-bottom pb-10 m-0" v-translate:view_sign_documents="lang">
          View or Sign Documents
        </p>
      </div>
      <div id="main">
        <div id="faq" class="activity1-container activity-section" v-for="(document, index) in participantDocumentList" :key="index">
          <div class="card faq-card">
            <div class="card-header faqhead3 text-center" v-if="document">
              <a class="btn btn-header-link" @click="navigateTab(document)">
                <span v-if="document.docName == eulaAgrementDoc" v-translate:eula_document_name="lang">{{ document.docName }}</span>
                <span
                  v-else
                  v-translate:dynamic_string="{
                    key: (document.docName.toLowerCase() == 'datavant tokenization consent') ? 'datavant_consent_form_title' : `${document.consentId}_consentName`,
                    val: lang,
                    html: document.docName
                  }"
                  >{{ document.docName }}</span
                >
                <span
                  class="float-right"
                  :class="{
                    'primary-text': document.status != 'SignedByParticipant'
                  }"
                  :style="document.status == 'SignedByParticipant' ? 'color: grey' : ''"
                >
                  {{ getTranslatedDocumentLabel(document) }}
                </span>
              </a>
            </div>
          </div>
        </div>
      </div>
      <div class="text-center vs-document-btn pt-48 mt-auto pl-49 pr-49 pb-38">
        <button class="btn leave_study_cntue primary-bg" @click="getParticipantDocuments()" v-translate:refresh_screen="lang">
          Refresh Screen
        </button>
      </div>
    </div>
    <DocumentDetalis v-if="onDocumentClick" :active="onDocumentClick" :eulaAgrementDoc="eulaAgrementDoc" @backButtonClicked="documentDetailsBackButtonClicked" :document="currentDocument" @onDocCompleted="onDocCompleted" />
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import { Bitrise, Widget, Consent } from "@/components/services/participant-service";
import DocumentDetalis from "./document-detail";
export default {
  name: "documents",

  data() {
    return {
      bitrise: new Bitrise(),
      widget: new Widget(),
      consent: new Consent(),
      currentDocument: "",
      onDocumentClick: false,
      cohorts: [],
      participantDocumentList: [],
      eulaAgrementDoc: "THREAD Study Application End User License Agreement"
    };
  },
  components: {
    DocumentDetalis
  },
  computed: {
    ...mapGetters(["participant"]),
    lang() {
      const selectedLanguage = this.$store.getters.getParticipantsPortalLanguages;
      return selectedLanguage ? selectedLanguage.language_culture : "en";
    },

    associatedConsents() {
      return this.cohorts.map(c => c.associatedConsent);
    }
  },

  mounted() {
    this.onDocumentClick = false;
    this.getCohorts();
    this.getParticipantDocuments();
  },

  methods: {
    documentDetailsBackButtonClicked() {
      this.onDocumentClick = false;
      this.getParticipantDocuments();
    },
    unbindCancelAndBack() {
      this.$root.$emit("SetBackButtonClickEvent", null);
      this.$root.$emit("SetCancelButtonVisibility", false);
      this.$root.$emit("SetBackButtonVisibility", true);
    },
    onDocCompleted() {
      this.onDocumentClick = false;
      this.getParticipantDocuments();
    },
    getParticipantDocuments() {
      this.unbindCancelAndBack();
      this.$api.getParticipantDocuments(this.participant.pid, this.participant.studyId).then(res => {
        this.participantDocumentList = res.body;
      });
    },
    getTranslatedDocumentLabel(doc){
      return (doc.status == "Declined" ? this.widget.translate('declined', 'Declined') : doc.status == "SignatureNotRequested" ? this.widget.translate('label_view', 'View') : (doc.status == "RequestedSignature") ? this.widget.translate('label_sign', 'Sign') : this.widget.translate('label_signed', 'Signed'));
    },
    getCohorts() {
      this.consent
        .getCohartData()
        .then(res => {
          this.cohorts = res;
        })
        .catch(err => {
          const message = this.widget.translate(err.message, "Data sync failed, please try again after some time.");
          if (message) {
            this.$toastr.error(message);
          }
        });
    },
    navigateTab(data) {
      this.onDocumentClick = true;
      this.currentDocument = data;
    },
    showLicense(data) {
      this.$router.push({
        name: "participants-portal-profile-documents-detail",
        params: { name: data }
      });
    }
  }
};
</script>

<style scoped>
#main {
  margin: 33px;
}
.card {
  box-shadow: 0 4px 4px 0 rgba(0, 0, 0, 0.25);
}
#main #faq .card {
  margin: 0px;
}
.activity1-container {
  min-height: auto;
  padding: 15px;
}
@media only screen and (min-width: 320px) and (max-width: 767px) {
  #main {
    margin: 0;
  }
}
@media only screen and (min-width: 768px) and (max-width: 1024px) {
  .activity1-container {
    padding: 15px;
  }
}
</style>
